import Endpoint from '../Endpoint'

export default class Profile extends Endpoint {
  async suggestEmployees(prefix) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/suggest_employees',
      data: { prefix },
    })
  }

  async suggestTopics(prefix) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/suggest_topics',
      data: { prefix },
    })
  }

  async suggestSchools(prefix) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/suggest_schools',
      data: { prefix },
    })
  }

  async suggest(prefix) {
    /**
     * Does a search against multiple endpoints at once. The combined
     * results contain a type field telling one what endpoint the result
     * came from.
     */
    if (!prefix) {
      // No prefix? Save the bandwith and return an empty result set.
      return []
    }
    const results = await Promise.all([
      this.suggestTopics(prefix),
      this.suggestSchools(prefix),
    ])
    return [
      ...results[0].data.map(x => ({ ...x, type: 'topic' })),
      ...results[1].data.map(x => ({ ...x, type: 'school' })),
    ]
  }

  async findEmployees(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/employees',
      data: params,
    })
  }

  async findActivities(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/activities',
      data: params,
    })
  }

  async findSchools(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/schools',
      data: params,
    })
  }

  async findTopics(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/search/topics',
      data: params,
    })
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/Search.js